import React, { useState } from "react";
import "../styles/VoidReasonsModal.css";

const VoidReasonsModal = ({ reasons, onClose, onConfirm, numeroCheque, mesa, articuloId }) => {
  const [selectedReason, setSelectedReason] = useState(null);

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  const handleConfirm = () => {
    if (!selectedReason) {
      alert("Por favor, selecciona una razón.");
      return;
    }
    if (!numeroCheque || !mesa || !articuloId) {
      alert("Faltan datos necesarios para la cancelación.");
      return;
    }

    // Pasar el objeto reason completo
    onConfirm(selectedReason);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="void-modal-content" onClick={handleContentClick}>
        <h3>Seleccionar razón de cancelación</h3>
        <div className="void-reasons-list">
          {reasons && reasons.length > 0 ? (
            reasons.map((reason) => (
              <button
                key={reason.id}
                onClick={() => setSelectedReason(reason)}
                className={selectedReason?.id === reason.id ? "selected" : ""}
              >
                {reason.name}
              </button>
            ))
          ) : (
            <p>No hay razones de cancelación disponibles.</p>
          )}
        </div>
        <div className="modal-actions">
          <button className="cancel-btn" onClick={onClose}>
            Cancelar
          </button>
          <button
            className="confirm-btn"
            onClick={handleConfirm}
            disabled={!selectedReason}
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};

export default VoidReasonsModal;